<template>
  <!-- Modal Register -->
  <div id="modal-register">
    <div
      id="modalRegister"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="resetForm()"
            >
              &times;
            </button>
          </div>
          <div class="modal-body pl-5 pr-5">
            <div class="form-signup">
              <div class="text-center mb-4">
                <p class="title mb-3 font-weight-thin">
                  Sign Up
                </p>
                <div class="row text-center">
                  <div class="col-6">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input 
                        id="customRadioInline1"
                        v-model="formRegistration.typeAcc" 
                        type="radio" 
                        name="customRadioInline1"
                        value="VS"
                        class="custom-control-input"
                        :class="{
                          error: $v.formRegistration.typeAcc.$error,
                          dirty: !$v.formRegistration.typeAcc.$invalid,
                        }"
                      >
                      <label
                        class="custom-control-label"
                        for="customRadioInline1"
                      >Ship Owner</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        id="customRadioInline2" 
                        v-model="formRegistration.typeAcc" 
                        type="radio" 
                        name="customRadioInline1" 
                        value="CR" 
                        class="custom-control-input"
                        :class="{
                          error: $v.formRegistration.typeAcc.$error,
                          dirty: !$v.formRegistration.typeAcc.$invalid,
                        }"
                      >
                      <label
                        class="custom-control-label"
                        for="customRadioInline2"
                      >Cargo Owner</label>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="form-label-group">
                <input 
                  id="inputName" 
                  v-model.trim="$v.formRegistration.name.$model" 
                  type="text" 
                  placeholder=""
                  class="form-control"
                  :class="{
                    'is-invalid': $v.formRegistration.name.$error,
                    'is-valid': !$v.formRegistration.name.$invalid,
                  }"
                  autofocus 
                  @keyup.enter="register"
                >
                <label for="inputName">Name</label>
              </div>

              <div class="form-label-group">
                <input 
                  id="inputEmail" 
                  v-model.trim="$v.formRegistration.email.$model" 
                  type="email" 
                  placeholder=""
                  class="form-control" 
                  :class="{
                    'is-invalid': $v.formRegistration.email.$error,
                    'is-valid': !$v.formRegistration.email.$invalid,
                  }"
                  @keyup.enter="register"
                >
                <label for="inputEmail">Email address</label>
                <div class="invalid-feedback">
                  Email format does not match. 
                </div>
              </div>

              <div class="form-label-group">
                <input 
                  id="inputCompany" 
                  v-model.trim="$v.formRegistration.company.$model" 
                  type="text" 
                  placeholder=""
                  class="form-control" 
                  :class="{
                    'is-invalid': $v.formRegistration.company.$error,
                    'is-valid': !$v.formRegistration.company.$invalid,
                  }"
                  @keyup.enter="register"
                >
                <label for="inputCompany">Company</label>
              </div>
              
              <div class="form-label-group">
                <select 
                  id="inputCountry" 
                  v-model.trim="$v.formRegistration.country.$model" 
                  type="text" 
                  placeholder=""
                  class="form-control" 
                  :class="{
                    error: $v.formRegistration.country.$error,
                    dirty: !$v.formRegistration.country.$invalid,
                  }"
                  @keyup.enter="register"
                >
                  <option
                    v-for="(item, index) in tempDataCountry"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <label for="inputCountry">Country</label>
              </div>

              <div class="form-label-group tooltippw w-100">
                <input  
                  id="inputPassword" 
                  v-model.trim="$v.formRegistration.password.$model" 
                  class="form-control"
                  placeholder=""
                  :type="passwordFieldType"
                  :class="{
                    'is-invalid': (!validPassword && formRegistration.password.length > 0) || $v.formRegistration.password.$error,
                    'is-valid': (validPassword && formRegistration.password.length > 0) && !$v.formRegistration.password.$invalid,
                  }"
                  @keyup.enter="register"
                  @input="check_password"
                >
                <label for="inputPassword">Password</label>
                <span
                  class="field-icon mt-2"
                  :class="iconShowPassword"
                  @click="show_password()"
                />
                <div class="valid-feedback">
                  Looks Good!
                </div>
                <div class="invalid-feedback">
                  Password format does not match. 
                </div>
                <div class="tooltiptext">
                  <ul class="mt-3">
                    <li><small class="text-muted">Use at least:</small></li>
                    <li :class="{ is_valid: passwordHint.upper }">
                      <small>Contains uppercase</small>
                    </li>
                    <li :class="{ is_valid: passwordHint.lower }">
                      <small>Contains lowercase</small>
                    </li>
                    <li :class="{ is_valid: passwordHint.number }">
                      <small>Contains number</small>
                    </li>
                    <li :class="{ is_valid: passwordHint.min }">
                      <small>Min 8 character</small>
                    </li>
                  </ul>
                </div>
              </div>
         
              <button
                v-if="currentAct.isLoading"
                class="btn btn-primary btn-block mx-0"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </button>
              <button
                v-else
                class="btn btn-primary btn-block mx-0"
                @click="register"
              >
                Sign Up
              </button>
              <button
                class="btn btn-outline-primary btn-block mx-0"
                data-toggle="modal"
                data-target="#modalLogin"
                data-dismiss="modal"
              >
                Log In
              </button>
              <p class="mt-2 mb-3 text-muted text-center">
                &copy; 2020
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  required,
  email,
  maxLength,
  minLength,
  integer
} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import $ from "jquery";
export default {
  name: "Navbar",
  data() {
    return {
      formRegistration: {
        tipeAcc: null,
        name: '',
        email: '',
        company: '',
        country: 'null',
        // state: null,
        // city: null,
        password: ''
        // confirmPassword: null,
      },
      placeholder: {
        email: "example@zonasea.com",
        password: "type your password",
        confirmPassword: "type same as password",
      },
      passwordHint:{
        lower: false,
        upper: false,
        min: false,
        number: false,
        length: null,
      },
      validPassword: false,
      passwordFieldType: "password",
      iconShowPassword: "fa fa-eye",
    };
  },

  validations: {
    formRegistration: {
      typeAcc: {
        required
      },
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(70),
      },
      email: {
        required,
        email,
        maxLength: maxLength(100),
      },
      company: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(70),
      },
      country: {
        required,
        integer,
      },
      password: {
        required,
        minLength: minLength(8),
      }
    },
  },
  computed: {
    currentAct () {
      return this.$store.getters["registrationAuth/getCurrentAct"]
    },
    tempDataCountry() {
      return this.$store.getters["registrationMasters/getCountry"];
    },
    tempDataState() {
      return this.$store.getters["registrationMasters/getState"];
    },
    tempDataCity() {
      return this.$store.getters["registrationMasters/getCity"];
    },
  },
  mounted() {
    this.load_country();
  },
  watch: {
    currentAct() {
      if (this.currentAct.hideModal === true) {
        this.resetForm();
        $("#modalRegister").modal("hide");
      }
    },
  },
  methods: {
    check_password(){
      this.passwordHint.length = this.formRegistration.password.length;
			
      if (this.passwordHint.length >= 8) {
        this.passwordHint.min = true;
      } else {
        this.passwordHint.min = false;
			}
			
      this.passwordHint.number = /\d/.test(this.formRegistration.password);
      this.passwordHint.upper = /[A-Z]/.test(this.formRegistration.password);
      this.passwordHint.lower = /[a-z]/.test(this.formRegistration.password);
      
      if (this.passwordHint.min === true &&
					this.passwordHint.upper === true &&
          this.passwordHint.lower === true &&
          this.passwordHint.number === true) {
						this.validPassword = true;
      } else {
        this.validPassword = false;
      }
    },
    resetForm() {
      this.$v.$reset();
      this.validPassword = false
      this.passwordHint.number = false
      this.passwordHint.upper = false
      this.passwordHint.lower = false
      this.passwordHint.min = false;
      this.passwordFieldType = 'password'
      this.iconShowPassword = "fa fa-eye"
      this.formRegistration = {
        typeAcc: null,
        name: '',
        email: '',
        company: '',
        country: null,
        password: '',
        confirmPassword: null,
      };
    },
    load_country() {
      this.$store.dispatch("registrationMasters/loadCountry");
    },
    // load_state() {
    //   let id_country = this.formRegistration.country;
    //   this.$store.dispatch("registrationMasters/loadState", id_country);
    // },
    // load_city() {
    //   let id_state = this.formRegistration.state;
    //   this.$store.dispatch("registrationMasters/loadCity", id_state);
    // },
    show_password() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.iconShowPassword =
        this.iconShowPassword === "fa fa-eye"
          ? "fa fa-eye-slash"
          : "fa fa-eye";
    },
    register() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.validPassword) {
        Swal.fire({
          title: "Oops...",
          text: "Tolong periksa kembali kolom yang masih kosong",
          icon: "warning",
          confirmButtonText: "Oke",
          focusCancel: true
        });
      } else {
        this.$store.dispatch("registrationAuth/registrationStart", this.formRegistration);
      }
    },
  },
};
</script>
<style lang="scss">

</style>
